import React from 'react';
import {OrbitComponent} from "../../../base-components/orbit-component/orbit-component";
import {PreviewBox} from "./boxes/preview.box";
import {OpenContainerBox} from "./boxes/open-container.box";
import {FilterItemTitleBox} from "./boxes/filter-item-title.box";
import {ContainerBox} from './boxes/container.box';
import {TitleContainerBox} from './boxes/title-container.box';
import {TitleBox} from './boxes/title.box';
import {FilterItemBox} from './boxes/filter-Item.box';
import {InputBox} from './boxes/input.box';
import {IArenaGameFiltersCategoryEditorViewModel} from '../../../../services/games-filter/arena-filters/categories/arena-game-filters-category-editor-view-model.interface';
import {IArenaGameFilterEditorViewModel} from '../../../../services/games-filter/arena-filters/filters/arena-game-filter-editor-view-model.interface';
import {observer} from 'mobx-react';

interface IFilterCategoryComponentProps {
    category: IArenaGameFiltersCategoryEditorViewModel;
    onCategoryToggled: (category: IArenaGameFiltersCategoryEditorViewModel) => void;
    isOpen: boolean;
}

@observer
export class FilterCategoryComponent extends OrbitComponent<IFilterCategoryComponentProps> {

    private _onFilterToggle = (filter: IArenaGameFilterEditorViewModel) => {
        if (filter.disabled) {
            return;
        }

        filter.toggleFilter();
    }

    _renderFilterList(category: IArenaGameFiltersCategoryEditorViewModel) {
        const filters = category.visibleFilters;
        const inputType = category.isMultiSelect ? 'checkbox' : 'radio';

        return <>
            {filters.map(filter => (
                <FilterItemBox key={filter.id} onClick={() => this._onFilterToggle(filter)} disabled={filter.disabled}>
                    <InputBox type={inputType} name={`${category.title}-option`} checked={!!filter.on} readOnly disabled={filter.disabled}/>
                    <FilterItemTitleBox className="filter-title">
                        {filter.text}
                        {filter.gamesCount > 0 && ` (${filter.gamesCount})`}
                    </FilterItemTitleBox>
                </FilterItemBox>
            ))}
        </>;
    }

    render() {
        const {category, isOpen} = this.props;
        const activeFiltersTexts = category.getAllAppliedFilters().map(f => f.text);
        const hasSubCategories = category.subCategories.length > 0;

        return (
            <ContainerBox>
                <TitleContainerBox onClick={() => this.props.onCategoryToggled(category)}>
                    <TitleBox isOpen={isOpen}>
                        {this.services.translation.translate(category.title)}
                        {category.gamesCount && ` (${category.gamesCount})`}
                    </TitleBox>

                    <PreviewBox isVisible={!isOpen && activeFiltersTexts.length > 0}>
                        {activeFiltersTexts.join(', ')}
                    </PreviewBox>
                </TitleContainerBox>

                <OpenContainerBox isOpen={isOpen}>
                    {this._renderFilterList(category)}

                    { hasSubCategories && <>
                        { category.subCategories.map(subCat => this._renderFilterList(subCat)) }
                    </> }
                </OpenContainerBox>
            </ContainerBox>
        );
    }
}
